import { isEmpty } from '@cat-ecom/common/utils/commonUtils';
import { NerSearchQuery } from 'services/internalSearch/types';
import { DealerPriceAvailabilityResponse } from 'services/dealerPriceAvailability/types';
import { transformPriceAndAvailability } from 'services/dealerPriceAvailability/utils';
import { PCC_SEARCH_RESULTS } from '../constants/analytics-constants';
import { isFilterByEquipment } from 'app/[lang]/[esite]/utils/filter-by-equipment';
import { PriceData } from '../_components/analytics-listener/types';

export const hasProducts = (productCount: string) => productCount !== '0';

export const isNerSearch = (nerSearchQuery: NerSearchQuery) => {
  const { modifiedQuery } = nerSearchQuery || {};
  return !isEmpty(nerSearchQuery) && !isEmpty(modifiedQuery);
};

const getUnformattedTotalPrice = (
  priceData: DealerPriceAvailabilityResponse,
  partNumber: string
) => {
  const price = priceData.priceAndAvailability.find(
    (priceData) => priceData.partNumber === partNumber
  );

  return price?.unformattedTotalPrice;
};

export const transformProductPriceData = (
  products: Product[],
  priceData: DealerPriceAvailabilityResponse,
  serialNumber: string,
  fitmentList: ProductFitmentResponse
) => {
  let productPriceData: PriceData;
  const data = products?.map((product) => {
    if (priceData) {
      const {
        item: {
          availability,
          price,
          weight,
          quantity,
          categoryPath,
          replacementParts,
          partLevelFlags,
          sosCode
        },
        currency,
        isGstAvailable,
        gstIncludesTax
      } = transformPriceAndAvailability(priceData, product.partNumber);
      productPriceData = {
        availability,
        price,
        weight,
        quantity,
        categoryPath,
        currency,
        unformattedTotalPrice: getUnformattedTotalPrice(
          priceData,
          product.partNumber
        ),

        replacementParts,
        isGstAvailable,
        gstIncludesTax,
        partLevelFlags,
        sosCode
      };
    }
    const fitmentCheck = fitmentList?.[product.partNumber]?.isSerialCompatible
      ? 'fity'
      : 'fitn';

    return {
      ...product,
      ...(priceData && { productPriceData }),
      serialNumber,
      fitmentCheck,
      listNameAndId: PCC_SEARCH_RESULTS
    };
  });
  return data;
};

export const getUpdatedProductCount = (productCount: string) => {
  const exceedingResults = '1200';
  return +productCount > 1200 ? exceedingResults : productCount;
};

export const isNerActive = (
  isNerEnabled: string,
  filterByEquipment: string,
  isMatchingMyEquipment: boolean
) =>
  isNerEnabled !== 'false' &&
  isFilterByEquipment(filterByEquipment) &&
  !isMatchingMyEquipment;
